export default {
  computed: {
    notificationFields() {
      return [
        {
          name: 'phone_number',
          key: 'phone_number',
          label: this.$t('global.field.whatsappNumber'),
          placeholder: this.$t('fleetTaskInstant.placeholder.whatsappNumber'),
          type: 'text'
        }
      ]
    }
  }
}